export const displayName = (p) => {
  if (!p) return "";
  const last = (p.last_name || "").trim().toUpperCase();
  const first = (p.first_name || "").trim();
  return [last, first].filter(Boolean).join(" ");
};

export const normalize = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z]/g, "");
